<template>
	<div class="ExpertvideoBox">
		<!--<div class="common-header-wrap">
			<mt-header class="common-header" title="达人主页">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>		
			</mt-header>
		</div>-->
		
		<div class="VideoHeaderBox">
			<div class="VideoHeaderTop">
				<span @click="$router.go(-1)">
					<img src="../../../assets/image/video/xleft.png" />
				</span>
			</div>
			
			<div class="VideoHeaderUserBox">
				<div class="UserAvatarBox">
					<img :src="Userdata.svideoman_pic" />
				</div>
				
				<div class="UserDetailsBox">
					<h3>{{Userdata.svideoman_name}}</h3>
					<!--<p>会员名:{{Userdata.member_name}}</p>-->
					<p class="shop" @click="goShopDetail">{{Userdata.store_name}}</p>
				</div>
			</div>
			
			<div class="UserAttentionBox">
				<p><span>{{Userdata.like_num}}</span>Recived Likes</p>
				<p><span>{{Userdata.fans_num}}</span>Following</p>
				<p><span>{{Userdata.focus_num}}</span>Followers</p>
			</div>
		</div>
		
		<div class="UserIntroductionBox" v-if="Userdata.self_intro">
			<p>{{Userdata.self_intro}}</p>
		</div>
		
		<div class="UserBottomBox">
			<a v-if="this.is_focus==0" href="javascript:;" @click="gofollow"><span>+</span>Following</a>
			<a v-else href="javascript:;" @click="CancelFollow">Followed</a>
			
			<a href="javascript:;" class="UserChat" @click="goOnline">
				<img src="../../../assets/image/video/xxings.png"/>
				Message</a>
		</div>
		
		<div class="VideoListBoxs" id="demo">
			<ul>
				<li v-for="(item, index) in videolist" :key="index" @click="govideo(item.svideo_id,index)">
					<span class="Toppings"v-if="item.svideo_top==1">Top</span>
					<div class="VideoImgs">
						<img v-bind:src="item.svideo_pic" />
					</div>
					<div class="GiveThumbs">
						
						<img src="../../../assets/image/video/livebai.png" />
						<span>{{item.svideo_like_count}}</span>
						<p>{{item.svideo_name}}</p>
					</div>
				</li>
			</ul>
		</div>
		<div>
			<div class="Loading" v-if="Loadingshow">Loading......</div>
			<div class="Loading" v-if="NoLoadingshow">No more</div>
		</div>
	</div>
</template>

<script>
	import { getvideouser,getbeFans,getcancelFocus } from '../../../api/video'
	import { getbuyerview} from '../../../api/common'
	import { mapState } from 'vuex'
	import { Toast } from 'mint-ui'
export default {
  name: 'video_index',
  data () {
    return {
      videoman_id:this.$route.query.svideoman_id,
      Userdata:{},
      svideoman_id:"",
      currentpages:1,
      pagetotal:2,
      is_focus:"",
      videolist:"",
      member_id:"",
      store_id:"",
      Loadingshow:false,
      NoLoadingshow:false,
      dates:"",
      enddates:"",
      home_url:"",
    }
  },
  
  components: {
    
  },
  mounted () {
	window.addEventListener('beforeunload', (event) => {
      if(this.user && this.store_id!=""){
    		this.buyerview();
    	}
    });
  },
  //跳转离开页面时
  destroyed() {
      if(this.user && this.store_id!=""){
    		this.buyerview();
      }
  },
  created: function () {
  	if(this.user){
  		this.member_id=this.user.member_id;
  	}
  	
  	getvideouser(this.videoman_id,this.member_id,this.currentpages).then((res) => {
		this.Userdata=res.result.man_info;
		this.is_focus=res.result.is_focus;
		this.svideoman_id=res.result.man_info.svideoman_id;
		this.videolist=res.result.video_list;
    	this.store_id=res.result.man_info.store_id;
    	this.pagetotal=res.result.page_total;
    	window.onscroll=this.PrintPageScroll;
   })
   this.dates=Date.parse(new Date());
   this.home_url = window.location.href;
  },
  computed: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    })
  },
  methods: {
  	//滑动加载更多
	PrintPageScroll(){	
		// 获取滚动的距离
	    let scrollTop=document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
	    // 获取滚动的高度（获取整个html的高度）
	    let scrollHeight=document.getElementById('demo').scrollHeight;
	    // 获取屏幕(浏览器)高度
	    let clienHeight=document.documentElement.clientHeight;
	    // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
	    if(scrollTop+clienHeight-scrollHeight >=100){
		    	window.removeEventListener("scroll",this.PrintPageScroll);
		    	//我到底了
		    	if(this.currentpages<this.pagetotal){
		    		this.currentpages=this.currentpages+1;
		      		this.Loadingshow = true;
		    		this.PrintFestivalList();
		    	}else{
		    		this.Loadingshow = false;
		    		this.NoLoadingshow=true;
		    	}	
	    	}
	      //滚动至底部后请求数据
	},
	PrintFestivalList(){
		getvideouser(this.videoman_id,this.member_id,this.currentpages).then((res) => {

			this.videolist=this.videolist.concat(res.result.video_list);
	    	window.addEventListener("scroll",this.PrintPageScroll);
	  })
	},
  	//关注
  	gofollow:function(){
		if(this.isOnline){
	  		getbeFans(this.svideoman_id,this.user.member_id).then((res) => {
				
				Toast(res.message);
				if(res.code==10000){
					this.is_focus=1;
				}else{
				}

		   })	
		}else{
			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
		}
  		
  	},
  	//取消关注
  	CancelFollow:function(){
  		if(this.isOnline){
	  		getcancelFocus(this.svideoman_id,this.user.member_id).then((res) => {
				if(res.code==10000){
					this.is_focus=0;
					Toast(res.message);
					
				}else{
					Toast(res.message);
				}

		   })	
		}else{
			var redirecturl = window.location.href;
	  		this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
		}
  	},
  	//IM聊天
  	goOnline () {
    	
      if (!this.user) {
        Toast('Please login first');
        var redirecturl = window.location.href;
	      this.$router.push({ name: 'HomeMemberLogin', query: { clear: 1 ,redirecturl:redirecturl} })
      } else if (this.user.member_id == this.Userdata.member_id) {
        Toast("Can't chat with yourself")
      } else {
        this.$router.push({ name: 'MemberChatInfo', query: { t_id: this.Userdata.member_id } 		})
      }
    },
//	视频详情
	govideo:function(videoids,index){
		if(index=0){index=1}
		index=Math.ceil(index/20)
		this.$router.push({ name: 'HomeVideoDetails', query: { videoid: videoids,pages:index,type:1} })
	},
	//进店
    goShopDetail() {
      this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': this.store_id } })
    },
     //发送统计
  	buyerview:function(){
    	this.enddates=Date.parse(new Date());
		  this.enddates=(this.enddates-this.dates)/1000;
		  if(this.enddates<1){
		  	this.enddates=1;
		  }else if(this.enddates>3600){
		  	this.enddates=3600;
		  }
    	getbuyerview(this.user.member_id,this.home_url,this.enddates,"2",this.store_id).then((res)=> {
    		
    	})
    }
  }
}	


</script>

<style scoped>
	.Loading{line-height: 1rem;text-align: center;font-size: 0.8rem;margin-top: 2rem;color: #818181;padding-bottom: 2rem;}
	.ExpertvideoBox{padding: 0;background: #fff;}
	.VideoHeaderBox{background-image: url(../../../assets/image/video/videobj.jpg);background-position: left top;background-size: 100% 100%;background-repeat: no-repeat;padding: 0.5rem 0.3rem;padding-bottom: 1.5rem;}
	.VideoHeaderTop span{display: inline-block;cursor: pointer;}
	.VideoHeaderTop span img{width: 1rem;}
	.VideoHeaderUserBox{padding: 0.5rem 0.5rem;padding-right: 0rem;}
	.UserAvatarBox{display: inline-block;box-sizing: border-box;vertical-align: middle;width: 4rem;height: 4rem;line-height: 3.6rem;border-radius: 50%;border: 3px solid #fff;text-align: center;overflow: hidden;}
	.UserAvatarBox img{max-width: 100%;max-height: 100%;}
	.UserDetailsBox{display: inline-block;box-sizing: border-box;vertical-align: middle;width: calc(100% - 4.5rem);padding-left: 0.8rem;}
	.UserDetailsBox h3{font-size: 0.8rem;color: #fff;margin: 0;padding: 0;font-weight: normal;line-height: 1.4rem;}
	.UserDetailsBox p{margin: 0;font-size: 0.6rem;color: #e9e9e9;margin-top: 0.1rem;line-height: 0.8rem;}
	.UserDetailsBox p.shop{background-image: url(../../../assets/image/video/dingwei.png);background-position: left center;background-size: 0.7rem;padding-left: 0.8rem;background-repeat: no-repeat;}
	.UserAttentionBox{padding: 0.5rem 0.5rem;}
	.UserAttentionBox p{display: inline-block;margin: 0;color: #e9e9e9;font-size: 0.7rem;margin-right: 0.8rem;line-height: 1rem;}
	.UserAttentionBox p span{font-weight: bold;color: #fff;display: inline-block;margin-right: 3px;font-size: 0.8rem;vertical-align: top;}
	
	.UserIntroductionBox{background: #fff;border-radius: 0.8rem;box-sizing: border-box;padding: 0.5rem;margin-top: -1.2rem;}
	.UserIntroductionBox p{font-size: 0.7rem;margin: 0;color: #000;line-height: 1.2rem;}
	.UserBottomBox{text-align: center;padding: 0.3rem 0;}
	.UserBottomBox a{display: inline-block;width: 47%;margin: 0 1%;background: #FF0000;color: #fff;padding: 0.3rem 0.1rem;box-sizing: border-box;font-size: 0.7rem;font-weight: normal;line-height: 1rem;}
	.UserBottomBox a span{display: inline-block;margin-right: 2px;font-weight: bold;}
	.UserBottomBox a.UserChat{background-color: #e3e3e3;color: #707070;}
	.UserBottomBox a.UserChat img{height: 0.9rem;display: inline-block;line-height: 1rem;}
	
	.VideoListBoxs{padding: 0.3rem 0.3rem;}
	.VideoListBoxs ul{display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;box-sizing: border-box;padding-left: 1px;}
	.VideoListBoxs ul li{width: 33.3%;float: left;box-sizing: border-box;border: 1px solid #ccc;margin-left: -1px;position: relative;margin-top: -1px;}
	.VideoImgs{height: 7rem;text-align: center;overflow: hidden;line-height: 6.5rem;font-size: 0rem;background-color: #000;}
	.VideoImgs img{width: 100%;display: inline-block;vertical-align: middle;}
	.GiveThumbs{position: absolute;width: 100%;box-sizing: border-box;left: 0;bottom: 0rem;padding: 0.1rem 0.2rem;background-image: linear-gradient(to top, #000, transparent);padding-bottom: 0.2rem;}
	.GiveThumbs img{height: 0.5rem;vertical-align: middle;display: inline-block;}
	.GiveThumbs span{display: inline-block;margin-left: 3px;font-size: 0.6rem;color: #fff;}
	.GiveThumbs p{font-size: 0.3rem;color: #fff;margin: 0;line-height: 0.6rem;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
	.Toppings{ display: inline-block; color: #fff; padding: 0 6px; border-radius: 3px; background: #d9001b; margin-right: 0px; line-height: 20px; position: absolute; top: 2px; left: 3px; z-index: 99; font-size: 12px; }
</style>